import React, { useEffect } from "react";
import "./styles/app.scss";
import { Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./Components/UI/Navbar";
import Constrution from "./Components/UI/Constrution";
import Homepage from "./Components/Homepage";
import Footer from "./Pages/Home/Footer";
import MainDoctor from "./Pages/SingleDoctor/MainDoctor";
import SubDoctor from "./Pages/SingleDoctor/SubDoctor";
import ScrollTop from "./Components/UI/ScrollTop.jsx";
import AllEquipments from "./Components/AllEquipments";
import SingleTreatment from "./Components/SingleTreatment";
import Specialists from "./Pages/Specialists/Specialists";
import AboutUsPage from "./Pages/AboutUs/AboutUsPage";
import Contact from "./Pages/Contact/Contact";
import Appointment from "./Pages/Contact/Appointment";
import Asthetics from "./Pages/Treatments/Asthetics";
import AntiAging from "./Pages/Treatments/AntiAging";
import BodyShapping from "./Pages/Treatments/BodyShapping";
import Dermatology from "./Pages/Treatments/Dermatology";
import Sexology from "./Pages/Treatments/Sexology";
import Blogs from "./Pages/Blogs/Blogs";
import Videos from "./Pages/VideoPage/Videos";
import PatientsResults from "./Components/PatientsResults";
import SingleBlog from "./Components/SingleBlog";
import SingleSeminar from "./Components/SingleSeminar";
import DhakaDermatology from "./Components/DDI/DhakaDermatology";
import { useState } from "react";
import Locations from "./Pages/Locations";
import RecentBlog from "./Components/RecentBlog";
import AuthPage from "./Pages/Auth/AuthPage.jsx";
import Undifiend from "./Pages/util/Undifiend.jsx";
import PaymentSuccess from "./Pages/util/PaymentSuccess.jsx";
import PaymentFailed from "./Pages/util/PaymentFailed.jsx";
import PaymentCancel from "./Pages/util/PaymentCancel.jsx";
import UserProfile from "./Pages/UserProfile.jsx";

function App() {
  const [singleDoc, setSingleDoc] = useState({});
  const [singleTreat, setSingleTreat] = useState({});
  const [singleSeminar, setSingleSeminar] = useState({});
  const [singleBlog, setSingleBlog] = useState({});
  const [recentBlog, setRecentBlog] = useState({});
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    setUserInfo(JSON.parse(localStorage.getItem("userInfo")));
  }, []);

  return (
    <div className="app">
      <Navbar />
      <ScrollTop />
      <Routes>
        <Route
          index
          element={
            <Homepage
              setSingleDoc={setSingleDoc}
              setSingleSeminar={setSingleSeminar}
              setSingleBlog={setSingleBlog}
            />
          }
        />
        <Route
          path="/about-us"
          element={<AboutUsPage setSingleDoc={setSingleDoc} />}
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/chief-specialist" element={<MainDoctor />} />
        <Route
          path="/related-specialist"
          element={<SubDoctor singleDoc={singleDoc} />}
        />
        <Route path="/all-equipments" element={<AllEquipments />} />
        <Route
          path="/treatment"
          element={<SingleTreatment singleTreat={singleTreat} />}
        />
        <Route
          path="/specialist"
          element={<Specialists setSingleDoc={setSingleDoc} />}
        />
        <Route path="/videos" element={<Videos />} />
        <Route
          path="/blogs"
          element={
            <Blogs
              setSingleBlog={setSingleBlog}
              setRecentBlog={setRecentBlog}
            />
          }
        />
        <Route path="/patient-results" element={<PatientsResults />} />
        <Route
          path="/single-blog"
          element={<SingleBlog singleBlog={singleBlog} />}
        />
        <Route
          path="/recent-blog"
          element={<RecentBlog recentBlog={recentBlog} />}
        />
        <Route
          path="/single-seminar"
          element={<SingleSeminar singleSeminar={singleSeminar} />}
        />

        {/* Trainings */}
        <Route path="/trainings" element={<DhakaDermatology />} />

        {/* treatments */}

        <Route
          path="/asthetic-treatments"
          element={<Asthetics setSingleTreat={setSingleTreat} />}
        />
        <Route
          path="/anti-aging-treatments"
          element={<AntiAging setSingleTreat={setSingleTreat} />}
        />
        <Route
          path="/body-shaping-treatments"
          element={<BodyShapping setSingleTreat={setSingleTreat} />}
        />
        <Route
          path="/dermatology-treatments"
          element={<Dermatology setSingleTreat={setSingleTreat} />}
        />
        <Route
          path="/sexology-treatments"
          element={<Sexology setSingleTreat={setSingleTreat} />}
        />

        <Route path="/locations" element={<Locations />} />
        <Route
          path="/login"
          element={userInfo ? <Navigate to="/profile" /> : <AuthPage />}
        />

        <Route
          path="/profile"
          element={userInfo ? <UserProfile /> : <Navigate to="/login" />}
        />
        <Route path="*" element={<Undifiend />} />
        <Route path="payment-success" element={<PaymentSuccess />} />
        <Route path="payment-failed" element={<PaymentFailed />} />
        <Route path="payment-cancel" element={<PaymentCancel />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
